{
  "Your Stripe account, your branding, your price": "Jouw Stripe-account, jouw huisstijl, jouw prijs",
  "Our fee is just US $1.50 per ticket sold (introductory offer)": "Onze vergoeding is slechts US$ 1,50 per verkocht ticket (introductieaanbod)",
  "All countries and 31 currencies supported": "Alle landen en 31 valuta ondersteund",
  "A fixed price, or let buyers choose the price": "Een vaste prijs, of laat kopers zelf de prijs kiezen",
  "Coupons and other Stripe features": "Coupons en andere Stripe-functies",
  "Currency": "Valuta",
  "Loading currencies…": "Valuta laden…",
  "Amount": "Bedrag",
  "Fee": "Kosten",
  "{code} - {name} (No auto-conversion)": "{code} - {name} (geen automatische omrekening)",
  "Search currency...": "Valuta zoeken...",
  "Add currency": "Valuta toevoegen",
  "Single day {price} (24h access)": "Eén dag {price} (24 uur toegang)",
  "All {days} days {price}": "Alle {days} dagen {price}",
  "Livestream {price} (no replay)": "Livestream {price} (zonder opname)",
  "Livestream {price}": "Livestream {price}",
  "Livestream + Replay {price}": "Livestream + opname {price}",
  "+ video download add-on {price}": "+ videodownload als extra {price}",
  "+ service & processing fee at checkout": "+ service- en verwerkingskosten bij het afrekenen",
  "Video download {price} (live-only event — no replay)": "Videodownload {price} (evenement alleen live — geen opname)",
  "Nothing (live-only event with downloads off)": "Niets (evenement alleen live, downloads uit)",
  "Replay {price}": "Opname {price}",
  "Replay + download": "Opname + download",
  "What buyers will see": "Wat kopers zien",
  "Before & during the event: {items}": "Voor en tijdens het evenement: {items}",
  "After the event: {items}": "Na het evenement: {items}",
  "Unlink Stripe Account": "Stripe-account ontkoppelen",
  "Are you sure you want to unlink your Stripe account? This will disable ticket sales for this event.": "Weet je zeker dat je je Stripe-account wilt ontkoppelen? Dan stopt de ticketverkoop voor dit evenement.",
  "Failed to unlink Stripe account. Please try again.": "Het Stripe-account kon niet worden ontkoppeld. Probeer het opnieuw.",
  "Sell tickets": "Tickets verkopen",
  "Couldn't load currencies": "Valuta konden niet worden geladen",
  "Check your connection and try again.": "Controleer je verbinding en probeer het opnieuw.",
  "Guests pay to watch, and the money goes straight to your Stripe account.": "Gasten betalen om te kijken, en het geld gaat rechtstreeks naar je Stripe-account.",
  "Tickets for rooms": "Tickets voor zalen",
  "Connect Stripe account": "Stripe-account koppelen",
  "Copy link to connect Stripe": "Link kopiëren om Stripe te koppelen",
  "Send it to the Stripe account's owner.": "Stuur hem naar de eigenaar van het Stripe-account.",
  "Not your Stripe account? Send the link to its owner so they can connect it.": "Niet jouw Stripe-account? Stuur de link naar de eigenaar, zodat die het account kan koppelen.",
  "Stripe fees, refunds and chargebacks are the connected account holder's responsibility. Need help setting up? Ask us in the support chat.": "Stripe-kosten, terugbetalingen en chargebacks zijn de verantwoordelijkheid van de houder van het gekoppelde account. Hulp nodig bij het instellen? Vraag het ons in de supportchat.",
  "Stripe account connected": "Stripe-account gekoppeld",
  "Stripe dashboard": "Stripe-dashboard",
  "Refresh": "Vernieuwen",
  "Unlink": "Ontkoppelen",
  "How guests pay": "Hoe gasten betalen",
  "Disable Pay-Per-View": "Pay-per-view uitschakelen",
  "Use Existing Stripe Price": "Bestaande Stripe-prijs gebruiken",
  "Custom Price (Fixed)": "Eigen prijs (vast)",
  "Customer Chooses Price": "Klant kiest de prijs",
  "Choose how guests pay": "Kies hoe gasten betalen",
  "Select Stripe Price": "Kies een Stripe-prijs",
  "price|None": "Geen",
  "Custom Prices": "Eigen prijzen",
  "This event is live-only, so the ticket includes the livestream only (no replay).": "Dit evenement is alleen live, dus het ticket geeft alleen toegang tot de livestream (geen opname).",
  "The ticket includes the livestream.": "Het ticket geeft toegang tot de livestream.",
  "The ticket includes the livestream and the replay.": "Het ticket geeft toegang tot de livestream en de opname.",
  "Set prices for each currency. First currency becomes the default.": "Stel prijzen in per valuta. De eerste valuta wordt de standaard.",
  "Sell single-day tickets": "Dagtickets verkopen",
  "Your price above is the All-Days ticket. Set one price per day below — buyers choose which day. Single-day access lasts 24 hours from that day's scheduled start time.": "Je prijs hierboven geldt voor het ticket voor alle dagen. Stel hieronder één prijs per dag in — kopers kiezen welke dag. Toegang voor één dag duurt 24 uur vanaf de geplande begintijd van die dag.",
  "Sell video download": "Videodownload verkopen",
  "Buyers can add the downloadable video to any ticket for this amount.": "Kopers kunnen de downloadbare video voor dit bedrag aan elk ticket toevoegen.",
  "After the event it's sold on its own since this event is live-only.": "Na het evenement wordt de download los verkocht, omdat dit evenement alleen live is.",
  "After the event it's sold as Replay + Download.": "Na het evenement wordt de download verkocht als “Opname + download”.",
  "Single-day buyers can only download their day.": "Kopers van een dagticket kunnen alleen hun eigen dag downloaden.",
  "+ Set a different replay price after the event (optional)": "+ Stel een andere prijs in voor de opname na het evenement (optioneel)",
  "Replay price after the event": "Prijs van de opname na het evenement",
  "Use ticket price": "Ticketprijs gebruiken",
  "Once the event is over, new buyers pay this instead of the ticket price. You can also change any price at any time.": "Zodra het evenement voorbij is, betalen nieuwe kopers dit bedrag in plaats van de ticketprijs. Je kunt elke prijs ook altijd wijzigen.",
  "Add fees at checkout (buyers pay the fees)": "Kosten toevoegen bij het afrekenen (kopers betalen de kosten)",
  "Buyers pay one combined EventLive + card processing fee on top of your price, so you receive the full amount you set (card fees are estimated at the standard rate — unusual cards may vary slightly).": "Kopers betalen bovenop je prijs één gecombineerd bedrag voor de EventLive-kosten en de kaartverwerkingskosten, zodat jij het volledige bedrag ontvangt dat je hebt ingesteld (de kaartkosten zijn geschat op het standaardtarief — bij ongebruikelijke kaarten kan dit iets afwijken).",
  "Fees are currently deducted from your price: the EventLive fee shown above plus Stripe's card processing fee.": "De kosten worden nu van je prijs afgetrokken: de EventLive-kosten hierboven plus de kaartverwerkingskosten van Stripe.",
  "Default Price Suggestions": "Voorgestelde bedragen",
  "These are suggested amounts customers will see, but they can enter any amount they wish.": "Dit zijn de voorgestelde bedragen die klanten zien, maar ze kunnen elk bedrag invullen dat ze willen.",
  "More settings": "Meer instellingen",
  "Upload logo in Profile Settings": "Logo uploaden in je profielinstellingen",
  "Invite free viewers in Guest List": "Gratis kijkers uitnodigen via de gastenlijst",
  "Customize event branding": "Huisstijl van het evenement aanpassen",
  "Enable payment emails in Stripe": "Betalingsmails inschakelen in Stripe",
  "Customize branding in Stripe": "Huisstijl aanpassen in Stripe",
  "Credits Added Successfully": "Credits toegevoegd",
  "Thank You for Your Purchase!": "Bedankt voor je aankoop!",
  "Your credits are ready to use. You can now:": "Je credits zijn klaar voor gebruik. Je kunt nu:",
  "You can now:": "Je kunt nu:",
  "Use your credits to unlock more events": "Je credits gebruiken om meer evenementen te ontgrendelen",
  "Check your available balance before your next purchase": "Je beschikbare saldo bekijken voor je volgende aankoop",
  "Return to your events and keep editing": "Teruggaan naar je evenementen en verder bewerken",
  "Invite guests to your event by sharing the event link or using the Guest List feature": "Gasten uitnodigen voor je evenement door de evenementlink te delen of de gastenlijst te gebruiken",
  "Open \"How to Go Live\" for a step-by-step guide": "“Zo ga je live” openen voor een stapsgewijze uitleg",
  "Go live on the day of your event": "Live gaan op de dag van je evenement",
  "Return to Event": "Terug naar evenement",
  "View My Events": "Mijn evenementen bekijken",
  "Afghanistan": "Afghanistan",
  "Åland Islands": "Åland",
  "Albania": "Albanië",
  "Algeria": "Algerije",
  "American Samoa": "Amerikaans-Samoa",
  "Andorra": "Andorra",
  "Angola": "Angola",
  "Anguilla": "Anguilla",
  "Antarctica": "Antarctica",
  "Antigua and Barbuda": "Antigua en Barbuda",
  "Argentina": "Argentinië",
  "Armenia": "Armenië",
  "Aruba": "Aruba",
  "Australia": "Australië",
  "Austria": "Oostenrijk",
  "Azerbaijan": "Azerbeidzjan",
  "Bahamas": "Bahama’s",
  "Bahrain": "Bahrein",
  "Bangladesh": "Bangladesh",
  "Belgium": "België",
  "Belize": "Belize",
  "Benin": "Benin",
  "Bermuda": "Bermuda",
  "Bhutan": "Bhutan",
  "Bolivia": "Bolivia",
  "Bosnia and Herzegovina": "Bosnië en Herzegovina",
  "Botswana": "Botswana",
  "Bouvet Island": "Bouveteiland",
  "Brazil": "Brazilië",
  "British Indian Ocean Territory": "Brits Indische Oceaanterritorium",
  "Brunei Darussalam": "Brunei",
  "Bulgaria": "Bulgarije",
  "Burkina Faso": "Burkina Faso",
  "Burundi": "Burundi",
  "Cambodia": "Cambodja",
  "Cameroon": "Kameroen",
  "Canada": "Canada",
  "Cape Verde": "Kaapverdië",
  "Cayman Islands": "Kaaimaneilanden",
  "Central African Republic": "Centraal-Afrikaanse Republiek",
  "Chad": "Tsjaad",
  "Chile": "Chili",
  "China": "China",
  "Christmas Island": "Christmaseiland",
  "Cocos (Keeling) Islands": "Cocoseilanden",
  "Colombia": "Colombia",
  "Comoros": "Comoren",
  "Congo": "Congo-Brazzaville",
  "Congo, The Democratic Republic of the": "Congo-Kinshasa",
  "Cook Islands": "Cookeilanden",
  "Costa Rica": "Costa Rica",
  "Cote D Ivoire": "Ivoorkust",
  "Croatia": "Kroatië",
  "Cuba": "Cuba",
  "Cyprus": "Cyprus",
  "Czech Republic": "Tsjechië",
  "Denmark": "Denemarken",
  "Djibouti": "Djibouti",
  "Dominica": "Dominica",
  "Dominican Republic": "Dominicaanse Republiek",
  "Ecuador": "Ecuador",
  "Egypt": "Egypte",
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Equatoriaal-Guinea",
  "Eritrea": "Eritrea",
  "Estonia": "Estland",
  "Ethiopia": "Ethiopië",
  "Falkland Islands (Malvinas)": "Falklandeilanden",
  "Faroe Islands": "Faeröer",
  "Fiji": "Fiji",
  "Finland": "Finland",
  "France": "Frankrijk",
  "French Guiana": "Frans-Guyana",
  "French Polynesia": "Frans-Polynesië",
  "French Southern Territories": "Franse Gebieden in de zuidelijke Indische Oceaan",
  "Gabon": "Gabon",
  "Gambia": "Gambia",
  "Georgia": "Georgië",
  "Germany": "Duitsland",
  "Ghana": "Ghana",
  "Gibraltar": "Gibraltar",
  "Greece": "Griekenland",
  "Greenland": "Groenland",
  "Grenada": "Grenada",
  "Guadeloupe": "Guadeloupe",
  "Guam": "Guam",
  "Guatemala": "Guatemala",
  "Guernsey": "Guernsey",
  "Guinea": "Guinee",
  "Guinea-Bissau": "Guinee-Bissau",
  "Guyana": "Guyana",
  "Haiti": "Haïti",
  "Heard Island and Mcdonald Islands": "Heard en McDonaldeilanden",
  "Holy See (Vatican City State)": "Vaticaanstad",
  "Honduras": "Honduras",
  "Hong Kong": "Hongkong",
  "Hungary": "Hongarije",
  "Iceland": "IJsland",
  "India": "India",
  "Indonesia": "Indonesië",
  "Iran, Islamic Republic Of": "Iran",
  "Iraq": "Irak",
  "Ireland": "Ierland",
  "Isle of Man": "Isle of Man",
  "Israel": "Israël",
  "Italy": "Italië",
  "Jamaica": "Jamaica",
  "Japan": "Japan",
  "Jersey": "Jersey",
  "Jordan": "Jordanië",
  "Kazakhstan": "Kazachstan",
  "Kenya": "Kenia",
  "Kiribati": "Kiribati",
  "Korea, Democratic People Republic of": "Noord-Korea",
  "Korea, Republic of": "Zuid-Korea",
  "Kuwait": "Koeweit",
  "Kyrgyzstan": "Kirgizië",
  "Lao People Democratic Republic": "Laos",
  "Latvia": "Letland",
  "Lebanon": "Libanon",
  "Lesotho": "Lesotho",
  "Liberia": "Liberia",
  "Libyan Arab Jamahiriya": "Libië",
  "Liechtenstein": "Liechtenstein",
  "Lithuania": "Litouwen",
  "Luxembourg": "Luxemburg",
  "Macao": "Macau",
  "Macedonia, The Former Yugoslav Republic of": "Noord-Macedonië",
  "Madagascar": "Madagaskar",
  "Malawi": "Malawi",
  "Malaysia": "Maleisië",
  "Maldives": "Maldiven",
  "Mali": "Mali",
  "Malta": "Malta",
  "Marshall Islands": "Marshalleilanden",
  "Martinique": "Martinique",
  "Mauritania": "Mauritanië",
  "Mauritius": "Mauritius",
  "Mayotte": "Mayotte",
  "Mexico": "Mexico",
  "Micronesia, Federated States of": "Micronesia",
  "Moldova, Republic of": "Moldavië",
  "Monaco": "Monaco",
  "Mongolia": "Mongolië",
  "Montserrat": "Montserrat",
  "Morocco": "Marokko",
  "Mozambique": "Mozambique",
  "Myanmar": "Myanmar (Birma)",
  "Namibia": "Namibië",
  "Nauru": "Nauru",
  "Nepal": "Nepal",
  "Netherlands": "Nederland",
  "Netherlands Antilles": "Nederlandse Antillen",
  "New Caledonia": "Nieuw-Caledonië",
  "New Zealand": "Nieuw-Zeeland",
  "Nicaragua": "Nicaragua",
  "Niger": "Niger",
  "Nigeria": "Nigeria",
  "Niue": "Niue",
  "Norfolk Island": "Norfolk",
  "Northern Mariana Islands": "Noordelijke Marianen",
  "Norway": "Noorwegen",
  "Oman": "Oman",
  "Pakistan": "Pakistan",
  "Palau": "Palau",
  "Palestinian Territory, Occupied": "Palestina",
  "Panama": "Panama",
  "Papua New Guinea": "Papoea-Nieuw-Guinea",
  "Paraguay": "Paraguay",
  "Peru": "Peru",
  "Philippines": "Filipijnen",
  "Pitcairn": "Pitcairneilanden",
  "Poland": "Polen",
  "Portugal": "Portugal",
  "Puerto Rico": "Puerto Rico",
  "Qatar": "Qatar",
  "Reunion": "Réunion",
  "Romania": "Roemenië",
  "Russian Federation": "Rusland",
  "RWANDA": "Rwanda",
  "Saint Helena": "Sint-Helena",
  "Saint Kitts and Nevis": "Saint Kitts en Nevis",
  "Saint Lucia": "Saint Lucia",
  "Saint Pierre and Miquelon": "Saint-Pierre en Miquelon",
  "Saint Vincent and the Grenadines": "Saint Vincent en de Grenadines",
  "Samoa": "Samoa",
  "San Marino": "San Marino",
  "Sao Tome and Principe": "Sao Tomé en Principe",
  "Saudi Arabia": "Saoedi-Arabië",
  "Senegal": "Senegal",
  "Serbia and Montenegro": "Servië en Montenegro",
  "Seychelles": "Seychellen",
  "Sierra Leone": "Sierra Leone",
  "Singapore": "Singapore",
  "Slovakia": "Slowakije",
  "Slovenia": "Slovenië",
  "Solomon Islands": "Salomonseilanden",
  "Somalia": "Somalië",
  "South Africa": "Zuid-Afrika",
  "South Georgia and the South Sandwich Islands": "Zuid-Georgia en Zuidelijke Sandwicheilanden",
  "Spain": "Spanje",
  "Sri Lanka": "Sri Lanka",
  "Sudan": "Soedan",
  "Suriname": "Suriname",
  "Svalbard and Jan Mayen": "Spitsbergen en Jan Mayen",
  "Swaziland": "Eswatini",
  "Sweden": "Zweden",
  "Switzerland": "Zwitserland",
  "Syrian Arab Republic": "Syrië",
  "Taiwan, Province of China": "Taiwan",
  "Tajikistan": "Tadzjikistan",
  "Tanzania, United Republic of": "Tanzania",
  "Thailand": "Thailand",
  "Timor-Leste": "Oost-Timor",
  "Togo": "Togo",
  "Tokelau": "Tokelau",
  "Tonga": "Tonga",
  "Trinidad and Tobago": "Trinidad en Tobago",
  "Tunisia": "Tunesië",
  "Turkey": "Turkije",
  "Turkmenistan": "Turkmenistan",
  "Turks and Caicos Islands": "Turks- en Caicoseilanden",
  "Tuvalu": "Tuvalu",
  "Uganda": "Oeganda",
  "Ukraine": "Oekraïne",
  "United Arab Emirates": "Verenigde Arabische Emiraten",
  "United Kingdom": "Verenigd Koninkrijk",
  "United States": "Verenigde Staten",
  "United States Minor Outlying Islands": "Kleine afgelegen eilanden van de Verenigde Staten",
  "Uruguay": "Uruguay",
  "Uzbekistan": "Oezbekistan",
  "Vanuatu": "Vanuatu",
  "Venezuela": "Venezuela",
  "Viet Nam": "Vietnam",
  "Virgin Islands, British": "Britse Maagdeneilanden",
  "Virgin Islands, U.S.": "Amerikaanse Maagdeneilanden",
  "Wallis and Futuna": "Wallis en Futuna",
  "Western Sahara": "Westelijke Sahara",
  "Yemen": "Jemen",
  "Zambia": "Zambia",
  "Zimbabwe": "Zimbabwe",
  "Your client's account · used for {count} event": {
    "one": "Account van je klant · gebruikt voor {count} evenement",
    "other": "Account van je klant · gebruikt voor {count} evenementen"
  },
  "Your client's account": "Account van je klant",
  "Your account · used for {count} event": {
    "one": "Je account · gebruikt voor {count} evenement",
    "other": "Je account · gebruikt voor {count} evenementen"
  },
  "Your account": "Je account",
  "Used for {count} event": {
    "one": "Gebruikt voor {count} evenement",
    "other": "Gebruikt voor {count} evenementen"
  },
  "Connected before": "Eerder gekoppeld",
  "Ticket payouts for “{event}” will go to {account}, your client's Stripe account. Use it only for this client's events.": "Ticketopbrengsten van “{event}” gaan naar {account}, het Stripe-account van je klant. Gebruik dit account alleen voor evenementen van deze klant.",
  "Ticket payouts for “{event}” will go to {account}.": "Ticketopbrengsten van “{event}” gaan naar {account}.",
  "Use this account": "Dit account gebruiken",
  "Couldn't use this Stripe account": "Dit Stripe-account kon niet worden gebruikt",
  "Use a Stripe account you've connected before": "Gebruik een Stripe-account dat je eerder hebt gekoppeld",
  "Or connect another Stripe account:": "Of koppel een ander Stripe-account:",
  "Connect another Stripe account": "Ander Stripe-account koppelen"
}
